import React from 'react';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import { Button } from 'react-bootstrap';
import axios from './../../constants/axios';
import { connect } from 'react-redux';
import InputControl from './../FormTemplate/InputControl';
import Select from './../FormTemplate/Select';
import TextareaControl from '../FormTemplate/TextareaControl';
import SelectAsync from '../FormTemplate/SelectAsync';

class NewContactForm extends React.Component {
   constructor(props) {
      super(props);
      this.state = {
         thanas: [],
         addressTypes: []
      };
   }

   componentDidMount() {
      axios.get('contacts/getContactAddressTypes')
         .then((res) => {
            let n = res.data.map(function (i) {
               return {
                  label: i.name,
                  value: i.id
               };
            });
            this.setState({
               addressTypes: n
            });
         });
   }

   componentWillReceiveProps(nextProps, oldProps) {
      if (nextProps.districtId === null) {
         this.setState({
            thanas: []
         });
      } else {
         if (nextProps.districtId !== oldProps.districtId) {
            axios.get(`districts/${nextProps.districtId}/thanas/getThanasByDistrictId`)
               .then((res) => {
                  let n = res.data.map(function (i) {
                     return {
                        label: i.name,
                        value: i.id
                     };
                  });
                  this.setState({
                     thanas: n
                  });
               });
         }
      }
   }

   render() {
      const { handleSubmit, createNewContact, contactTypes } = this.props;
      const { thanas, addressTypes } = this.state;
      return (
         <div>
            <h3>New Contact Form</h3>
            <form noValidate="true" autoComplete="off" onSubmit={handleSubmit(createNewContact)} >
               <Field name="name" component={InputControl} type="text" label="Contact Name" />
               <Field name="mobile" component={InputControl} type="text" label="Contact Mobile" />
               <Field name="contact_type_id" component={Select} options={contactTypes} />

               <Field name="address" component={TextareaControl} label="Address" />
               <Field name="district_id" component={SelectAsync} link="/districts/searchByName" label="District" />
               <Field name="thana_id" component={Select} allowEmpty={true} options={thanas} label="Thana" />
               <Field name="contact_address_type_id" component={Select} options={addressTypes} label="Contact Type" />

               <Button type="submit" bsStyle="primary" block >Save</Button>
            </form>
         </div>
      );
   }
}
NewContactForm.propTypes = {
   handleSubmit: React.PropTypes.func,
   createNewContact: React.PropTypes.func,
   contactTypes: React.PropTypes.array
};

NewContactForm = reduxForm({ // eslint-disable-line
   form: 'newContactForm',
   initialValues: {
      contact_type_id: 4, /// Customer
      contact_address_type_id: 2, // Resident
      district_id: 26,
      thana_id: 508,
   }
})(NewContactForm);

const selector = formValueSelector('newContactForm');
NewContactForm = connect(state => { // eslint-disable-line
   const districtId = selector(state, 'district_id');
   return {
      districtId
   };
})(NewContactForm);
export default NewContactForm;



/** WEBPACK FOOTER **
 ** ./src/components/Contact/NewContactForm.js
 **/